import { css } from 'aphrodite';
import * as React from 'react';
import { IContact } from '../../../extViewmodels';
import { getDisplayName } from '../../../models/NameUtils';
import { Avatar } from '@HoudiniUI/Avatar';
import { getAvatarProps } from '@AppModels/AvatarUtils';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	contact?: IContact;
}

export const CardableContact: React.FC<IProps> = ({ className = '', contact }) => {
	return (
		<div className={`${css(styleSheet.section, styleSheet.contactContainer)} ${className}`}>
			{!!contact && (
				<>
					<div className={css(styleSheet.avatarContainer)}>
						<Avatar {...getAvatarProps(contact)} />
					</div>
					<div className={css(styleSheet.contactInfoContainer)}>
						<div className='contact-name'>{getDisplayName(contact)}</div>
						{!!contact.jobTitle && <div className='contact-job-title'>{contact.jobTitle}</div>}
						{contact.primaryEmail ? (
							<div className='contact-email'>{contact.primaryEmail.value}</div>
						) : contact.emailAddresses?.length ? (
							<div className='contact-email'>{contact.emailAddresses[0].value}</div>
						) : null}
					</div>
				</>
			)}
		</div>
	);
};
